import {deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getLoggedUserRoleService = async(payload) =>{
    //return await getData(`user/getSecurityLevel?userEmail=${payload}`);
    return await getData(`user/getUserInfo?userEmail=${payload}`);
}

export const getLoggedUserIdService = async(payload) =>{
    return await getData(`user/getAssociatedId?userEmail=${payload}`);
}